import styled from 'styled-components';
import {
    Badge,
    Heading,
    Box,
    Group,
    Image,
    Text,
    color,
    radius,
    spacing,
    fontSize,
    palette,
} from '@landr/maestro';

const ChartIndexMarkerMobileSize = '30px'; /* @maestro-no-token */
const ChartListImageSize = '54px'; /* @maestro-no-token */
const ChartListImageMobileSize = '40px'; /* @maestro-no-token */

export const ChartHeading = styled(Heading)`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${spacing('lg')};

    svg {
        height: ${fontSize('xxxl')};
        margin-right: ${spacing('sm')};
    }
`;

export const Row = styled(Group)`
    align-items: center;
    border-bottom: 1px solid ${color('neutral.900')};
    padding-top: ${spacing('lg')};
    padding-bottom: ${spacing('lg')};
    padding-left: ${spacing('xs')};
    padding-right: ${spacing('xs')};

    :hover {
        background-color: ${palette('neutral.900')};
        border-radius: ${radius('base')};
    }
`;

export const Index = styled(Group.Item)`
    flex-shrink: 0;
    height: ${spacing('xxl')};
    width: ${spacing('xxl')};
    border-radius: ${spacing('xxl')};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${color('neutral.900')};
    font-size: ${fontSize('lg')};
    margin-right: ${spacing('md')};

    ${({ theme }) => theme.breakpoint('lg')`
        height: ${ChartIndexMarkerMobileSize};
        min-width: ${ChartIndexMarkerMobileSize};
        border-radius: ${ChartIndexMarkerMobileSize};
        margin-right: ${spacing('sm')};
        font-size: ${fontSize('md')};
    `}
`;

export const IconWrapper = styled(Group.Item)`
    width: ${spacing('xl')};
    height: ${spacing('xl')};
    flex-shrink: 0;
    margin-right: ${spacing('md')};
    ${({ theme }) => theme.breakpoint('lg')`
    width: ${spacing('lg')};
    height: ${spacing('lg')};
            margin-left: auto;
            margin-right: 0;
        `}
`;

export const ItemImage = styled(Image)`
    flex-shrink: 0;
    background-color: ${palette('neutral.900')};
    height: ${ChartListImageSize};
    width: ${ChartListImageSize};
    margin-right: ${spacing('md')};
    border-radius: ${radius('base')};

    ${({ theme }) => theme.breakpoint('lg')`
        height: ${ChartListImageMobileSize};
        width: ${ChartListImageMobileSize};
        margin-right: ${spacing('sm')};
    `}
`;

export const DetailsContainer = styled.div`
    width: 100%;
    overflow: hidden;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
`;

export const DetailsHeadingWrapper = styled.div`
    width: 100%;
    display: block;
    align-items: center;
`;

export const NewBadge = styled(Badge)``;

export const DetailsHeading = styled(Text)<{ isNew: boolean }>`
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    font-weight: 700;

    max-width: 100%;

    ${({ isNew }) =>
        isNew &&
        `
        /* @maestro-no-token */
        max-width: calc(100% - 52px);
    `};

    font-size: ${fontSize('md')};
    margin-bottom: 0;

    ${({ theme }) => theme.breakpoint('lg')`
        line-height: ${fontSize('lg')};
    `}
`;

export const DetailsSubheading = styled(Text)`
    font-size: ${fontSize('sm')};

    ${({ theme }) => theme.breakpoint('lg')`
        line-height: ${fontSize('lg')};
    `}
`;

export const ChartLink = styled(Box)`
    margin-top: ${spacing('sm')};
`;

export const ChartWrapper = styled(Group.Item)`
    width: 33.33%;
    overflow: hidden;
    flex: 1 1 0;
    display: flex;
    min-height: 100%;
    flex-direction: column;
    justify-content: space-between;

    &:last-child {
        margin-right: 0;
    }

    ${({ theme }) => theme.breakpoint('lg')`
    width: 100%;
        margin-right: 0;
    `}
`;

export const ChartsDesktopWrapper = styled(Group)`
    display: flex;
    justify-content: space-between;
`;
